import { useTheme } from '@mui/material'
import placeholder from '@/shared/assets/images/loginScreen.webp'

export const useLoginScreenStyle = () => {
    const theme = useTheme()
    const primaryMain = theme.palette.primary.main
    const fontColor = 'white'
    const containerStyle = {
        zIndex: 0,
        height: '100%',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    }
    const backgroundImageContainerStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        zIndex: 0,
    }
    const backgroundImageStyle = {
        position: 'absolute',
        width: '100vw',
        height: '100vh',
        zIndex: 0,
        backgroundImage: `url("${placeholder}")`,
        backgroundPosition: 'center 35%',
        backgroundSize: 'cover',
    }
    const backgroundGradientOverlayStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(to top, rgba(0,0,0,0.9), rgba(0,0,0,0.6))',
        zIndex: 1,
        pointerEvents: 'none',
    }
    const logoStyle = {
        maxWidth: '271px',
        zIndex: 1,
    }
    const contentStyle = {
        marginTop: '20px',
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '10px',
        zIndex: 1,
    }
    const menusContainerStyle = {
        position: 'relative',
        width: '100%',
        justifyContent: 'center',
        padding: { xs: '16px', md: '40px' },
    }
    const headerStyle = {
        marginTop: '40px',
        color: fontColor,
        typography: 'headline2',
        zIndex: 1,
    }
    const subtitle1Style = {
        textAlign: { xs: 'center', md: 'unset' },
        typography: 'headline2',
        marginBottom: '20px',
        marginTop: '40px',
        color: fontColor,
        zIndex: 1,
        minWidth: { xs: 'unset', md: '900px' },
        padding: { xs: '0 16px', md: 0 },
    }
    const subtitle2Style = {
        textAlign: { xs: 'center', md: 'unset' },
        zIndex: 1,
        typography: 'label2',
        color: fontColor,
        marginTop: '20px',
        marginBottom: '40px',
    }

    const colorButtonStyle = {
        color: fontColor,
        borderRadius: '25px',
        background: `${primaryMain}`,
        paddingTop: '5px',
        paddingLeft: '25px',
        paddingRight: '25px',
        paddingBottom: '6px',
        minWidth: '130px',
        typography: 'text1',
        textTransform: 'none',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: `${primaryMain}`,
        },
    }
    const colorButtonGuestStyle = {
        background: `${theme.palette.white}`,
        borderRadius: '25px',
        paddingTop: '5px',
        paddingLeft: '25px',
        paddingRight: '25px',
        paddingBottom: '6px',
        minWidth: '130px',
        textTransform: 'none',
        color: `${theme.palette.black}`,
        marginTop: '10px',
        fontSize: '14px',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: `${theme.palette.white}`,
        },
    }
    const underLineButtonStyle = {
        color: fontColor,
        typography: 'text2',
        textDecoration: 'underline',
        textTransform: 'none',
        '&:hover': {
            cursor: 'pointer',
            backgroundColor: 'transparent',
        },
        marginTop: '20px',
    }
    const verticalLineStyle = {
        display: { xs: 'none', md: 'block' },
        position: 'absolute',
        height: '90%',
        borderLeft: '1px solid',
        transform: {
            xs: 'rotate(90deg)',
            md: 'unset',
        },
    }

    return {
        containerStyle,
        backgroundImageContainerStyle,
        backgroundImageStyle,
        backgroundGradientOverlayStyle,
        logoStyle,
        underLineButtonStyle,
        colorButtonStyle,
        colorButtonGuestStyle,
        menusContainerStyle,
        subtitle1Style,
        subtitle2Style,
        headerStyle,
        contentStyle,
        verticalLineStyle,
    }
}
